import {ListItem} from '@domain/common/list-view/list-item';

/**
 * Modèle d'une clef d'export API
 *
 * @author Lionel Gimenez
 */
export class ExportClef implements ListItem {
    /** Clef */
    clef: string;

    /** Valeur */
    valeur: string;

    /**
     * Récupération de l'identifiant de l'objet
     * @returns Identifiant unique de l'élément
     */
    getKey(): string {
        //Retourne la clef comme identifiant
        return this.clef;
    }
}
